
import { defineComponent, ref } from 'vue';

import cookie from '@/utils/cookie';
import HeaderLinks from '../components/HeaderLinks.vue';

export default defineComponent({
	components: {
		HeaderLinks,
	},

	setup() {
		const loggedIn = ref(cookie.get('token') ? true : false);

		return {
			loggedIn,
		};
	},
});
